var render = function render(){var _vm=this,_c=_vm._self._c;return _c('object',{attrs:{"data":_vm.source + '#view=fit',"type":"application/pdf","width":"100%","height":"100%"}},[_c('embed',{attrs:{"src":_vm.source + '#view=fit',"type":"application/pdf"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }